<template>
    <CTooltip
        :content="content"
        :placement="placement"
        :trigger="(!content || disabled) ? [] : ['hover', 'focus']"
    >
        <template #toggler="{ id, on }">
            <slot
                :id="id"
                :on="on"
            />
        </template>
    </CTooltip>
</template>

<script>
import { CTooltip } from '@coreui/vue'

export default {
    name: 'DTooltip',
    components: {
        CTooltip
    },
    props: {
        content: {
            type: String,
            required: true
        },
        placement: {
            type: String,
            default: 'top'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>
